import { createAction, props } from '@ngrx/store';

export enum GestiuniActions {
  GestiuniRequested = '[Gestiuni] Gestiuni Requested',
  GestiuniLoading = '[Gestiuni] Gestiuni Loading',
  GestiuniLoaded = '[Gestiuni] Gestiuni Loaded',
  GestiuniError = '[Gestiuni] Gestiuni Error',
  ExportInventory = '[Inventory] Export',
}

export const GestiuniRequested = createAction(GestiuniActions.GestiuniRequested);
export const GestiuniLoading = createAction(GestiuniActions.GestiuniLoading);
export const GestiuniLoaded = createAction(GestiuniActions.GestiuniLoaded,
  props<{ gestiuni: [] }>());
export const GestiuniError = createAction(GestiuniActions.GestiuniError);
export const ExportInventory = createAction(GestiuniActions.ExportInventory, props<{ inventoryId: string }>());
